"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (val) { return (val !== 'false' && val !== 'FALSE' && !!val); });
//# sourceMappingURL=to_boolean.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/reverb-js-common/to_boolean.js
// module id = +bv0
// module chunks = 20 21